
<template>
  <div>
    <v-hover v-slot="{ hover }">
      <div>
        <div class="d-flex align-center">
          <v-btn @click="closer ? (open = !open) : null"
                 style="text-transform: none !important;"
                 class="pl-1"
                 text>
            <v-icon v-if="closer"
                    v-text="open ?  'mdi-menu-up' : 'mdi-menu-down'"
                    color="#646566"
                    class="mr-2" />
            <div v-text="keyname + ' : '"
                 :class="closer ? '' : 'ml-8'"
                 class="mr-1" />
            <div v-text="valuestring"
                 :class="color" />
            <v-btn v-if="hover || isFavorited"
                   @click.stop="update()"
                   class="ml-1"
                   small
                   icon>
              <v-icon v-text="'mdi-star'"
                      :color="isFavorited ? ('primary') : (hover ? '#646566' : 'disabled')"
                      size="15" />
            </v-btn>
          </v-btn>
        </div>
        <div v-if="closer && open"
             class="ml-5">
          <recurrsive-object-print v-for="(value, key, index) in value"
                                   :key="`${ key }-${ index }`"
                                   :keyname="key"
                                   :value="value"
                                   :keypath="(keypath ? keypath + '.' : '') + key"
                                   :favorites="favorites"
                                   @Update="passUpdate">
          </recurrsive-object-print>
        </div>
        <div v-if="closer && open"
             v-text="closer"
             :class="color"
             class="pl-8" />
      </div>
    </v-hover>
  </div>
</template>


<script>
export default {
  name: "RecurrsiveObjectPrint",
  props: ["keyname", "value", "keypath", "favorites"],

  data() {
    return {
      open: false,
    };
  },

  mounted() {},

  methods: {
    update() {
      this.$emit("Update", { key: this.keypath, value: !this.isFavorited });
    },

    passUpdate(update) {
      this.$emit("Update", update);
    },
  },

  computed: {
    type() {
      if (this.value === null) {
        return "Null";
      }
      if (this.value === undefined) {
        return "Undefined";
      } else if (Array.isArray(this.value)) {
        return "Array";
      } else if (typeof this.value === "object") {
        return "Object";
      } else if (Number.isInteger(this.value)) {
        return "Int";
      } else if (typeof this.value == "boolean") {
        return "Bool";
      } else {
        return "String";
      }
    },

    color() {
      var retVal;
      switch (this.type) {
        case "Null":
        case "Undefined":
          retVal = "error--text";
          break;
        case "Array":
          retVal = "quaternary--text";
          break;
        case "Int":
        case "Bool":
          retVal = "tertiary--text";
          break;
        case "String":
          retVal = "primary--text";
          break;
        case "Object":
        default:
          retVal = "";
      }
      return retVal;
    },

    valuestring() {
      var retVal;
      switch (this.type) {
        case "Null":
          retVal = "null";
          break;
        case "Undefined":
          retVal = "undefined";
          break;
        case "Array":
          retVal = this.open ? "[" : "[" + this.value.length + "]";
          break;
        case "Object":
          var keys = Object.keys(this.value);
          retVal = this.open ? "{" : "{" + (keys.length ? keys.length + " keys" : "") + "}";
          break;
        case "String":
          retVal = !this.value ? '""' : '"' + this.value + '"';
          break;
        default:
          retVal = this.value;
      }
      return retVal;
    },

    closer() {
      var retVal;
      switch (this.type) {
        case "Array":
          retVal = this.value.length > 0 ? "]" : false;
          break;
        case "Object":
          var keys = Object.keys(this.value);
          retVal = keys.length > 0 ? "}" : false;
          break;
        default:
          retVal = false;
      }
      return retVal;
    },

    isFavorited() {
      return this.favorites.includes(this.keypath);
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
</style>

